import { Slot } from "./slot.model";

export class SlotRequest
{
    slots: Slot[];
}



// WEBPACK FOOTER //
// ./src/app/+common/model/slot-request.model.ts